import Clear from './../layouts/Clear.vue';

export default {
  path: '/categories',
  component: Clear,
  children: [
    {
      path: '',
      name: 'categories.index',
      component: () => import('@/views/categories/index.vue'),
    },
  ],
};
